import classNames from 'classnames';
import type { SystemButtonSize } from './SystemButton.types';

const radiusClassName: { [Key in SystemButtonSize]: string } = {
  'x-small': 'rounded-xs',
  small: 'rounded-xs',
  default: 'rounded-sm',
  large: 'rounded-sm',
};

export const getSystemButtonClassNames = (
  size: SystemButtonSize,
  className?: string,
  disabled?: boolean,
): string =>
  classNames(
    className,
    'inline-flex items-center justify-center',
    disabled
      ? 'text-status-disabled-dark bg-transparent'
      : 'text-default cursor-pointer focus-visible:outline-none focus-visible:ring hover:bg-state-hover active:bg-state-press',
    radiusClassName[size],
  );
